import React from 'react'
import iconMasterCard from '@loyal_images/payment/icon_mastercard.png'
import { Icon } from 'loyal-react'
const OrderSide = () => (
  <div className='cart-side col-12 col-md-4 border-ui-3 radius bg-white px-0 py-0 mt-2 mt-md-0'>
    <div className='col-12 py-3 px-3 mx-0 border-color-ui-3 border-bottom'>
      <h3 className='color-title txt-font-body'>Sobre o pedido</h3>
    </div>
    <div className='cart-subtotal col-12 pb-0 pb-md-3 mx-0'>
      <div className='row product-brand bg-ui-5 py-2  px-2  border-dotted-bottom border-color-ui-3'>
        <div className='col-3 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left  justify-content-center align-self-center '>
          <img
            className='w-100'
            src={iconMasterCard}
            alt='Bandeira selecionada'
          />
        </div>
        <div className='col-9  txt-left  justify-content-center align-self-center'>
          <p className='txt-body-sm txt-subtitle txt-font-body color-ui-2'>
            Cartão: <strong>XXXX-XXXX-XXXX-0278</strong>
          </p>
          <p className='txt-body-sm txt-subtitle txt-font-body color-ui-2'>
            Valor: <strong>3x R$ 1.950,00</strong>
          </p>
        </div>
      </div>
      <div className='row product-brand pt-3  px-2'>
        <div className='col-12 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left  justify-content-center align-self-center '>
          <p className='txt-body-sm txt-subtitle txt-font-body color-ui-2'>
            Resgate realizado em: 17/10/2018 às 14h13
          </p>
          <p className='txt-body-sm txt-subtitle txt-font-body color-ui-2'>
            Valor total em reales: 1456 reales
          </p>
          <p className='txt-body-sm txt-subtitle txt-font-body color-ui-2'>
            Complemento em dinheiro: R$ 5.850,00
          </p>
          <p className='txt-body-sm txt-subtitle txt-font-body color-ui-2'>
            Valor do frete Ponto Frio: 80 reales
          </p>
        </div>
      </div>
      <div className='row product-brand pt-2  px-2'>
        <div className='col-12 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left  justify-content-center align-self-center'>
          <p className='txt-body-sm txt-subtitle txt-font-body color-ui-2'>
            <strong>Adriana Santana</strong>
          </p>
          <p className='txt-body-sm txt-subtitle txt-font-body color-ui-2'>
            <strong>Alameda Rio Negro, 585 - 7º andar</strong>
          </p>
          <p className='txt-body-sm txt-subtitle txt-font-body color-ui-2'>
            <strong>Alphaville - Barueri - SP - 06454-000</strong>
          </p>
        </div>
      </div>

      <div className='cart-done row  px-2 pt-2 '>
        <div className='col-12 justify-content-center align-self-center'>
          <button className='btn-featured btn-icon'>
            <i className='icon icon_press' />
            Imprimir Pedido
          </button>
        </div>
      </div>
      <div className='row py-1 px-half d-block d-md-none mt-2 mt-md-0  border-dotted-top border-color-ui-3'>
        <div className='cart-back col-12 col-md-5 px-1 txt-left'>
          <button className='btn btn-sm btn-flat btn-icon'>
            <Icon className='icon icon-sm icon_left' />
            Ver todos os pedidos
          </button>
        </div>
      </div>
    </div>
  </div>
)

export default OrderSide



// WEBPACK FOOTER //
// ./src/features/User/Orders/OrderSide.js